export function removeItemFromConfig(
  config: any,
  key: string,
  keyValue: string
) {
  const walk = (node: any) => {
    if (Array.isArray(node)) {
      for (let i = node.length - 1; i >= 0; i--) {
        const child = node[i];
        if (child[key] === keyValue) {
          node.splice(i, 1);
        } else {
          walk(child);
        }
      }
      return;
    }
    if (node && typeof node === 'object') {
      for (const k of Object.keys(node)) walk(node[k]);
    }
  };
  walk(config);
}
